import { Content } from "../../squidex";
const cloneDeep = require('lodash.clonedeep');

export class AssetDirectoryModel extends Content {
    constructor(current?: Content) {
      if (current) {
        super(cloneDeep(current) as Content);
        } else {
            super({});
        }
    }
}
